"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montenerodomo": {
    "7beefbca": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "skipSearch": false
    }],
    "bosco-barone": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "038b94fd": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "skipSearch": false
    }],
    "casale": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "74403df1": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "skipSearch": false
    }],
    "lago-saraceno": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "991ad5b8": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "skipSearch": false
    }],
    "marangola": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e739719c": [{
      "hkey": "0fa6d411",
      "slug": "fonticelle",
      "name": "Fonticelle",
      "primary": true,
      "skipSearch": false
    }],
    "rione-fonticelle": [{
      "hkey": "0fa6d411",
      "slug": "fonticelle",
      "name": "Fonticelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "844352e2": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "skipSearch": false
    }],
    "schiera": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c2cd9cb8": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "skipSearch": false
    }],
    "tre-confini": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "413167b4": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "skipSearch": false
    }],
    "verlinghiera": [{
      "hkey": "9e22d1c1",
      "slug": "montenerodomo",
      "name": "Montenerodomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;